import * as React from "react";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  ChakraProvider
} from "@chakra-ui/react";
import ReactDOM from "react-dom/client";
import { theme } from "configs";

interface ModalInstance {
  open(props: {
    okText?: React.ReactNode;
    onOk(): void;
    description: React.ReactNode;
    title: React.ReactNode;
  }): void;
  close(): void;
}

const CONTAINER_ID = "modal-instance-root";

const getInstance = (): ModalInstance => {
  let root: ReactDOM.Root | null = null;

  const close: ModalInstance["close"] = () => {
    const container = document.querySelector(`#${CONTAINER_ID}`);

    if (root) {
      root.unmount();
      root = null;
    }
    if (container) {
      document.body.removeChild(container);
    }
  };

  const open: ModalInstance["open"] = ({
    description,
    title,
    okText = "Remove",
    onOk
  }) => {
    let container = document.querySelector(`#${CONTAINER_ID}`);
    if (!container) {
      container = document.createElement("div");
      container.id = CONTAINER_ID;
      document.body.appendChild(container);
    }

    root = ReactDOM.createRoot(container);

    root.render(
      <ChakraProvider theme={theme()}>
        <AlertDialog
          leastDestructiveRef={{ current: null }}
          isOpen
          onClose={close}
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                {title}
              </AlertDialogHeader>
              <AlertDialogBody>{description}</AlertDialogBody>
              <AlertDialogFooter>
                <Button colorScheme="gray" variant="outline" onClick={close}>
                  Cancel
                </Button>
                <Button
                  colorScheme="red"
                  ml={3}
                  onClick={() => {
                    onOk();
                    close();
                  }}
                >
                  {okText}
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </ChakraProvider>
    );
  };

  return { open, close };
};

const instance = getInstance();

export default instance;
